// extracted by mini-css-extract-plugin
export var icon = "_6l-1";
export var subtext = "_6l-0";